module.exports = __webpack_public_path__ + "static/img/award.8c357c32.png";